import styled from 'styled-components';

export const Em = styled.em`
  font-family: ${({ theme }) => theme.typography.fontFamilies.serifEd};
  font-style: italic;
  color: ${({ theme }) => theme.tone.halo.base};
  font-variation-settings: normal;
`;
